import { createSubscriptionFx } from './model';

createSubscriptionFx.doneData.watch(({ _links: { checkout } }) => {
    window.open(checkout.href, '_blank');
});
